import { useEffect } from 'react';

export const useJsonLd = (data, id = 'product-schema') => {
  useEffect(() => {
    if (!data) return;

    // 1. Buscar si ya existe el script para no duplicarlo
    let script = document.getElementById(id);

    if (!script) {
      script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }

    // 2. Inyectar los datos
    script.innerHTML = JSON.stringify(data);

    // 3. Limpieza: eliminar el script cuando el usuario salga de la página
    return () => {
      const currentScript = document.getElementById(id);
      if (currentScript) {
        document.head.removeChild(currentScript);
      }
    };
  }, [data, id]);
};